export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonOffset40.5a2fdb56.svg";